import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/banco-de-nomina';

/**
 * GET Banco de Nóminas
 * @returns {Promise<object[]>}
 */
export const getBancosDeNominas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    /* eslint-disable-next-line no-unreachable */
  } catch (err) {
    onError(err);
  }
  return [];
};
